// extracted by mini-css-extract-plugin
module.exports = {"searchJobList__jobList":"searchJobList__jobList","searchJobList__noResult":"searchJobList__noResult"};